import { render, staticRenderFns } from "./industryEdit.vue?vue&type=template&id=423ab0dc&"
import script from "./industryEdit.vue?vue&type=script&lang=js&"
export * from "./industryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports